import { Editor, Transforms, Element } from "slate";

const CustomEditor = {
    isMarkActive(editor, format) {
        const marks = Editor.marks(editor)
        return marks ? marks[format] === true : false
    },

    isCodeBlockActive(editor) {
        const [match] = Editor.nodes(editor, {
            match: n => n.type === 'code',
        })
        return !!match
    },

    toggleMark(editor, format) {
        const isActive = CustomEditor.isMarkActive(editor, format)
        if (isActive) {
            Editor.removeMark(editor, format)
        } else {
            Editor.addMark(editor, format, true)
        }
    },

    toggleCodeBlock(editor) {
        const isActive = CustomEditor.isCodeBlockActive(editor)
        Transforms.setNodes(
            editor,
            { type: isActive ? null : 'code' },
            { match: n => Element.isElement(n) && Editor.isBlock(editor, n) }
        )
    },

    toggleHeading(editor, format) {
        const isActive = CustomEditor.isHeadingActive(editor, format);
        Transforms.setNodes(
            editor,
            { type: isActive ? 'paragraph' : format },
            { match: (n) => Editor.isBlock(editor, n) }
        );
    },

    isHeadingActive(editor, format) {
        const [match] = Editor.nodes(editor, {
            match: (n) => n.type === format,
        });
        return !!match;
    },
}

const LIST_TYPES = ["numbered-list", "bulleted-list"]
const isListFormat = (format) => LIST_TYPES.includes(format);

const toggleBlock = (editor, format) => {
    const isList = isListFormat(format);
    const isActive = isBlockActive(editor, format);
    let type = isActive ? 'paragraph' : format;

    Transforms.unwrapNodes(editor, {
        match: (node) =>
            !Editor.isEditor(node) &&
            Element.isElement(node) &&
            isListFormat(node.type),
        split: true,
    });

    if (isList && !isActive) {
        type = "list-item";
        const block = { type: format, children: [] };
        Transforms.wrapNodes(editor, block);
    }

    Transforms.setNodes(
        editor,
        { type: type }
    );
};

const isBlockActive = (editor, format) => {
    const { selection } = editor;
    if (!selection) return false;

    const blockType = "type";
  
    const match = Array.from(
      Editor.nodes(editor, {
        at: Editor.unhangRange(editor, selection),
        match: (node) => {
          return (
            !Editor.isEditor(node) &&
            Element.isElement(node) &&
            node[blockType] === format
          );
        },
      })
    );
  
    return !!match?.[0];
};

export { toggleBlock };
export default CustomEditor;